export default function (distance , unit='m' ,convert=true) {

    let distanceInMiles = distance;
    if (process.env.VUE_APP_REGION === 'US') {
        if(convert === false){
            return distance + ' miles';
        }
        if(unit === 'm') {
            distanceInMiles = (distance * 0.000621371).toFixed(2) +' miles'; 
        }
        if(unit === 'km') {
            distanceInMiles = (distance * 0.621371).toFixed(2) +' miles'; 
        }
    }else{
        if(convert === false){
            return distance + ' km';
        }
        distanceInMiles = distance + ' km';
    }
   // Convert meters to miles and round to 2 decimal places
    return `${distanceInMiles}`;
}